import React, { useContext } from 'react';
import { GlobalPropsContext } from '../App';
const useGlobalVariables = () => {
  const globalProps = useContext(GlobalPropsContext);

  return globalProps;
};

export default useGlobalVariables;
